export default "__VITE_ASSET__BXinDkFP__"